/*!
* @Author: leo
* @Date: 2019-12-24 16:44:00
* @Last Modified by: leo
* @Last Modified time: 2019-12-24 16:44:00
* @Instruduction: element-ui 组件
*/

import Vue from 'vue'

import {
    Avatar,
    Button,
    Input,
    Form,
    FormItem,
    Table,
    TableColumn,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Row,
    RadioGroup,
    RadioButton,
    Col,
    Breadcrumb,
    BreadcrumbItem,
    Message,
    MessageBox,
    Pagination,
    Link,
    Card,
    Timeline,
    TimelineItem,
    Loading,
    Dialog,
    Tabs,
    TabPane,
    Tag,
    Divider,
    Cascader,
    Select,
    Option,
    Upload,
    Autocomplete,
    Backtop,
    Icon,
    DatePicker,
    Alert,
    Popover,
    Radio,
    Switch,
    CheckboxGroup,
    Checkbox,
    ButtonGroup,
    Slider,
    InputNumber,
    Progress,
    Descriptions,
    DescriptionsItem,
    Collapse,
    CollapseItem
} from 'element-ui'
// @ts-ignore
import Image from '@/components/el-image'
// @ts-ignore
import Tooltip from '@/components/itooltip'

Vue.use(Avatar)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Slider)
Vue.use(InputNumber)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Image)
Vue.use(Switch)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Radio)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Row)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Col)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Link)
Vue.use(Card)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Cascader)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Autocomplete)
Vue.use(Backtop)
Vue.use(Icon)
Vue.use(DatePicker)
Vue.use(Alert)
Vue.use(Popover)
Vue.use(Loading.directive)
Vue.use(Progress)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Collapse)
Vue.use(CollapseItem)

// 修改默认值

// @ts-ignore
Dialog.props.appendToBody.default = true

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message

// 对 Message 封装一边带关闭按钮的调用函数
const messageTypes = ['error', 'info', 'success', 'warning']
messageTypes.forEach((type: any) => {
    Vue.prototype[`$m${type}`] = (message: string) => Message({
        type,
        message,
        showClose: true
    })
})
